import { mdiTextBoxSearchOutline } from "@mdi/js";
import Icon from "@mdi/react";
import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import { getOfferId } from "src/services/OfferService";

const MobileReviewTooltip = ({ offer }: { offer: any }) => {
  const offerId = getOfferId(offer);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="offer-mobile-tooltip-container">
      <Tooltip
        target={`sportsbook-review-${offerId}1`}
        toggle={() => setIsOpen(!isOpen)}
        isOpen={isOpen}
        placement="top"
      >
        <span>{offer.sportsbook_name} Review</span>
      </Tooltip>
      <a id={`sportsbook-review-${offerId}1`} href={`/sportsbook-review/${offer.sportsbook_name?.toLowerCase()}`}>
        <Icon path={mdiTextBoxSearchOutline} size="22px" className="offer-mobile-tooltip-icon" />
      </a>
    </div>
  );
};

export default MobileReviewTooltip;
